import React, { useState, useEffect } from 'react';
import { useAuth } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { TaskPollingProvider } from './context/TaskPollingContext';
import LoginPage from './components/LoginPage';
import UnifiedUpload from './components/UnifiedUpload';
import ExtractFeatures from './components/ExtractFeatures';
import ExtractAttributes from './components/ExtractAttributes';
import ManageProjects from './components/ManageProjects';
import ToastContainer from './components/ToastContainer';

function App() {
  const { isAuthenticated, verifyAuth } = useAuth();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    // Check authentication status on app load
    const checkAuth = async () => {
      await verifyAuth();
      setLoading(false);
    };

    checkAuth();
  }, [verifyAuth]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  const tabs = [
    { id: 0, name: 'Unified Processing', component: 'UnifiedUpload' },
    { id: 1, name: 'Extract Features', component: 'ExtractFeatures' },
    { id: 2, name: 'Extract Attributes', component: 'ExtractAttributes' },
    { id: 3, name: 'Manage Projects', component: 'ManageProjects' }
  ];

  const renderCurrentTab = () => {
    switch(activeTab) {
      case 0:
        return <UnifiedUpload />;
      case 1:
        return <ExtractFeatures />;
      case 2:
        return <ExtractAttributes />;
      case 3:
        return <ManageProjects />;
      default:
        return <UnifiedUpload />;
    }
  };

  return (
    <NotificationProvider>
      <TaskPollingProvider>
        <div className="App min-h-screen bg-gray-50">
          <header className="bg-gray-800 text-white p-4 flex justify-between items-center">
            <h1 className="text-xl font-bold">🔍 Codebase Analyzer</h1>
            <button
              onClick={() => {
                localStorage.removeItem('access_token');
                window.location.reload();
              }}
              className="text-sm bg-red-600 hover:bg-red-700 text-white py-1 px-3 rounded"
            >
              Logout
            </button>
          </header>

          <div className="container mx-auto p-4">
            {/* Tabs */}
            <div className="flex border-b border-gray-200 mb-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`py-2 px-4 font-medium text-sm ${
                    activeTab === tab.id
                      ? 'text-blue-600 border-b-2 border-blue-600'
                      : 'text-gray-500 hover:text-gray-700'
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.name}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="bg-white rounded-lg shadow p-6">
              {renderCurrentTab()}
            </div>
          </div>

          {/* Global Toast Notifications */}
          <ToastContainer />
        </div>
      </TaskPollingProvider>
    </NotificationProvider>
  );
}

export default App;